import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ChatsViewMode = "by-account" | "all-chats";

interface WorkspaceState {
  selectedAccountId: string | null;
  selectedChatId: string | null;
  viewMode: ChatsViewMode;
  selectAccount: (id: string | null) => void;
  selectChat: (id: string | null) => void;
  selectChatWithAccount: (accountId: string, chatId: string) => void;
  setViewMode: (m: ChatsViewMode) => void;
}

export const useWorkspace = create<WorkspaceState>()(
  persist(
    (set) => ({
      selectedAccountId: null,
      selectedChatId: null,
      viewMode: "by-account",
      selectAccount: (id) => set({ selectedAccountId: id, selectedChatId: null }),
      selectChat: (id) => set({ selectedChatId: id }),
      selectChatWithAccount: (accountId, chatId) =>
        set({ selectedAccountId: accountId, selectedChatId: chatId }),
      setViewMode: (m) => set({ viewMode: m }),
    }),
    { name: "tmc-workspace" }
  )
);
